<template>
  <div class="br-modal">
    <div class="br-modal__dialog">
      <div class="br-modal__head">
        <span class="br-modal__title">View Whitepaper</span>
      </div>
      <div class="br-modal__body">
        <div class="notice">
          <div class="notice__icon">
            <i class="icon icon-question"/>
          </div>
          <div class="notice__content">
            <p><strong>Please Note</strong>: We will never share your contact details with any third-parties. Instead, we hope it's ok if we reach out to you occasionally.</p>
          </div>
        </div>

        <p>We know how hard it can be navigating the myriad of HR technology solutions. This short whitepaper covers all the basics of employing Artificial Intelligence (A.I.) alongside your current resources.</p>
        <p><strong>We hope you gain a better understanding of AI's ability to:</strong></p>
        <ul>
          <li>Improve interactions among your employees</li>
          <li>Foster community learning, sharing and development</li>
          <li>Encourage team comradery and belonging</li>
        </ul>

        <form
          id="whitepaper-form"
          class="form"
          @submit.prevent="submit">
          <div class="row">
            <div class="columns six">
              <FormText
                v-model="form.first_name"
                :rules="['required']"
                label="First Name"
                name="first_name"/>
            </div>
            <div class="columns six">
              <FormText
                v-model="form.last_name"
                :rules="['required']"
                label="Last Name"
                name="last_name"/>
            </div>
          </div>
          <div class="row">
            <div class="columns twelve">
              <div class="form-group form-group--required">
                <FormText
                  v-model="form.company"
                  :rules="['required']"
                  label="Company Name"
                  name="company"/>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="columns twelve">
              <div class="form-group form-group--required">
                <FormText
                  v-model="form.email"
                  :rules="['required', 'email']"
                  label="Email Address"
                  name="address"/>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="br-modal__foot">
        <button
          form="whitepaper-form"
          class="button u-pos-right u-border-radius">
          Submit
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    form: {
      first_name: null,
      last_name: null,
      company: null,
      email: null
    }
  }),
  methods: {
    async submit () {
      const validator = await this.$validator.validateAll()

      console.log(validator)

      if (validator) {
        await axios.post(this.route('whitepaper.request'), this.form)

        window.location.reload()
      }
    }
  }
}
</script>
